
import { useOnboarding } from "@/context/OnboardingContext";

const OnboardingProgress = () => {
  const { currentStep, totalSteps } = useOnboarding();
  
  // Calculate progress percentage
  const progressPercent = (currentStep / totalSteps) * 100;

  return (
    <div className="flex-1 min-w-0">
      <div className="flex justify-between items-center mb-1 text-xs sm:text-sm text-white/70 gap-2">
        <span className="whitespace-nowrap">Etapa {currentStep}/{totalSteps}</span>
        <span className="text-right tabular-nums">{Math.round(progressPercent)}%</span>
      </div>
      <div className="h-1.5 sm:h-2 w-full bg-black/30 backdrop-blur-sm rounded-full overflow-hidden border border-white/10">
        <div 
          className="h-full bg-luxury-pinkBright transition-all duration-500 ease-out"
          style={{ width: `${progressPercent}%` }}
        ></div>
      </div>
    </div>
  );
};

export default OnboardingProgress;
